import React from "react";
import { Col, Container, Row } from "react-grid-system";
import { FaFacebookF } from "react-icons/fa";
import { PiInstagramLogoThin } from "react-icons/pi";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import "./footer.scss";

interface FooterLayoutProps {
  settings: any;
  location: any;
}

const mapStateToProps = (state: any) => {
  return {
    settings: state.settings,
  };
};

function FooterLayout(props: FooterLayoutProps) {
  if (props.location.pathname === "/store"){
    return null;
  }
  return (
    <div className='footer'>
      <div className='page'>
        <Container fluid={true} className='footer-content'>
          <div className='desktop-footer'>
            <Row>
              <Col className='footer-column' xs={4} sm={4} md={4} lg={4}>
                <div className='item-title'>Холбоо барих</div>
                <div className='item'>
                  <span>Хаяг: {props.settings.address}</span>
                </div>
                <div className='item'>Имэйл: <span>{props.settings.supportEmail}</span></div>
                <div className='item'>Утас: <span>+976 {props.settings.supportPhone}</span></div>
              </Col>

              <Col className='footer-column' xs={4} sm={4} md={4} lg={4}>
                <div className='item-title'>Холбоосууд</div>
                <div className='item'>
                  <Link to='/about-us'>Бидний тухай</Link>
                </div>
                <div className='item'>
                  <Link to='/provider'>Нийлүүлэгч</Link>
                </div>
                <div className='item'>
                  <Link to='/store'>Дэлгүүр</Link>
                </div>
                <div className='item'>
                  <Link to='/terms'>Үйлчилгээний нөхцөл</Link>
                </div>
                {/* <div className='item'>
                  <Link to='/terms'>Нууцлалын бодлого</Link>
                </div> */}
              </Col>

              <Col className='footer-column' xs={4} sm={4} md={4} lg={4}>
                <img src='logo.png' alt='' className='logo' />
                <div className='item-title'>Сошиал хаягууд</div>
                <div className='item-icons'>
                  <a
                    href={props.settings.facebookMsgLink}
                    target='_blank'
                    rel='noopener noreferrer'>
                    <FaFacebookF className='main' size={15} />
                  </a>
                  <a
                    href='https://www.instagram.com/chef_pro'
                    target='_blank'
                    rel='noopener noreferrer'>
                    <PiInstagramLogoThin className='main' size={15} />
                  </a>
                  {/* <a
                    href='https://twitter.com/'
                    target='_blank'
                    rel='noopener noreferrer'>
                    <RiTwitterXFill className='main' size={15} />
                  </a>
                  <a
                    href='https://www.tiktok.com/'
                    target='_blank'
                    rel='noopener noreferrer'>
                    <RiTiktokFill className='main' size={15} />
                  </a>
                  <a
                    href='https://www.pinterest.com/'
                    target='_blank'
                    rel='noopener noreferrer'>
                    <FaPinterest className='main' size={15}  />
                  </a> */}
                </div>
              </Col>
            </Row>
          </div>

          <div className='mobile-footer'>
            <img src='logo.png' alt='logo' className='logo' />
            <Row>
              <Col className='footer-column' xs={12} sm={12}>
                <div className='item-title'>Холбоо барих</div>
                <div className='item'>
                  Наадамчдийн зам 77,<br />
                    Яармаг, 5-р хороо,<br />
                    Хан-Уул дүүрэг,<br />
                    Улаанбаатар хот,<br />
                </div>
                <div className='item'>Имэйл: <span>{props.settings.supportEmail}</span></div>
                <div className='item'>Утас: <span>+976 {props.settings.supportPhone}</span></div>

                <div className='item-title'>Холбоосууд</div>
                <div className='item removed'>
                  <Link to='/about-us'>Бидний тухай</Link>
                </div>
                <div className='item'>
                  <Link to='/store'>Дэлгүүр</Link>
                </div>
                <div className='item removed'>
                  <Link to='/provider'>Нийлүүлэгч</Link>
                </div>
                <div className='item removed'>
                  <Link to='/terms'>Үйлчилгээний нөхцөл</Link>
                </div>
                {/* <div className='item removed'>
                  <Link to='/terms'>Нууцлалын бодлого</Link>
                </div> */}

              <div className='item-title'>Сошиал хаягууд</div>
                <div className='item-icons'>
                  <a
                    href={props.settings.facebookMsgLink}
                    target='_blank'
                    rel='noopener noreferrer'>
                    <FaFacebookF className='main' size={15} />
                  </a>
                  <a
                    href='https://www.instagram.com/chef_pro'
                    target='_blank'
                    rel='noopener noreferrer'>
                    <PiInstagramLogoThin className='main' size={15} />
                  </a>
                  {/* <a
                    href='https://twitter.com/'
                    target='_blank'
                    rel='noopener noreferrer'>
                    <RiTwitterXFill className='main' size={15} />
                  </a>
                  <a
                    href='https://www.tiktok.com/'
                    target='_blank'
                    rel='noopener noreferrer'>
                    <RiTiktokFill className='main' size={15} />
                  </a>
                  <a
                    href='https://www.pinterest.com/'
                    target='_blank'
                    rel='noopener noreferrer'>
                    <FaPinterest className='main' size={15} />
                  </a> */}
                </div>
              </Col>
            </Row>
          </div>
        </Container>

        <Container fluid={true} className='copyright'>
          <Col>{props.settings.companyName} © {new Date().getFullYear()}</Col>
        </Container>
      </div>
    </div>
  );
}

export default withRouter(connect(mapStateToProps)(FooterLayout));
